// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__348vo","header":"Messages_header__1PeQY"};